import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import MessageAreaInfo, { MESSAGE_AREA_INFO_ALERTS } from "../../pages/utils/components/MessageAreaInfo";

export default function ImportantAlertBanner({ location = "all", onClose = () => {}}) {
  const [appProperties] = useContext(AppContext);
  return (
    <>
      {appProperties.alerts?.map((alert) => {
        if (alert?.locations?.includes?.(location) && MESSAGE_AREA_INFO_ALERTS[alert?.id]) {
            const messageAreaInfoProps = MESSAGE_AREA_INFO_ALERTS[alert?.id];
            return <MessageAreaInfo {...messageAreaInfoProps} message={messageAreaInfoProps?.getMessage?.(appProperties) ?? ""} appProperties={appProperties} onClose={onClose}/>;
        } else {
          return null;
        }
      })}
    </>
  );
}
